import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  top: 10%;
  left: 32.5%;
  width: 35%;
  max-height: 80%;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.32);
  overflow: auto;
  font-family: 'Roboto Slab', sans-serif;

  * {
    padding: 0;
    margin: 0;
  }

  /* RESPONSIVIDADE */

  
  /* laptop */
  @media (min-width: 1200px) {
    font-size: 18px;
  }

  /* laptop menor */
  @media (min-width: 993px) and (max-width: 1200px) {
    font-size: 16px;
    width: 45%;
  }

  /* tablets na horizontal */
  @media (min-width: 769px) and (max-width: 992px) {
    font-size: 14px;
    width: 44%;
  }

  /* tablets na vertical/celulares grandes */
  @media (min-width: 601px) and (max-width: 768px) {
    font-size: 14px;
    width: 43%;
  }

  /* Celulares pequenos */
  @media (min-width: 368px) and ( max-width: 600px) {
    position: absolute;
    width: 42%;
  }

`

export const MainText = styled.h1`
  position: relative;
  left: 20%;
  width: 60%;
  padding: 12px 0 8px 0;

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 18px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 16px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 14px;
  }

  /* tablets na vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 14px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 12px;
  }
`

export const LoginForm = styled.div`
  padding: 0 0 0 0;
  width: 100%;
  height: 190px;

  /* RESPONSIVIDADE */

  
  /* laptop */
  @media (min-width: 1200px) {
    font-size: 18px;
  }

  /* laptop menor */
  @media (min-width: 993px) and (max-width: 1200px) {
    font-size: 16px;
    width: 100%;
  }

  /* tablets na horizontal */
  @media (min-width: 769px) and (max-width: 992px) {
    font-size: 14px;
    width: 100%;
  }

  /* tablets na vertical/celulares grandes */
  @media (min-width: 601px) and (max-width: 768px) {
    font-size: 14px;
    width: 100%;
  }

  /* Celulares pequenos */
  @media (min-width: 368px) and ( max-width: 600px) {
    width: 100%;
  }
`

export const Label = styled.label`
  position: relative;
  left: 20%;
  width: 60%;
  display: block;
  padding: 15px 0 10px 0;

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 14px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 14px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 13px;
  }

  /* tablets na vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 12px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 11px;
  }
`

export const TextInput = styled.input`
  position: relative;
  left: 20%;
  width: 60%;
  text-align: left;
  min-height: 28px;
  background-color: #f1f1f2;
  border: 0;
  border-radius: 5px;
  padding: 0 0 0 5px;

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 14px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 13px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 12px;
  }

  /* tablets na vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 11px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 9px;
  }
`

export const InputButton = styled.input`
  position: relative;
  left: 20%;
  width: 60%;
  margin: 25px 0 25px 0;
  min-height: 28px;
  text-align: center;
  background-color: #6ec1e4;
  color: white;
  border: 0;
  border-radius: 5px;

  :hover {
    border: 1px black solid;
    cursor: pointer;
  }

  :active {
    background-color: #1f9dd4;
  }

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 15px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 14px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 13px;
  }

  /* tablets na vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 12px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 11px;
  }
`

export const PassReset = styled.p`
  position: relative;
  left: 20%;
  width: 60%;
  margin: 40px 0 20px 0;
  text-decoration: underline;
  cursor: pointer;

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 13px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 12px;
  }

  /* tablets na horizontal */
  @media (min-width: 601px) and (max-width: 992px) {
    font-size: 13px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 12px;
  }
`

export const OrLine = styled.div`
  display: flex;
`

export const LeftLine = styled.div`
  position: relative;
  left: 5%;
  width: 40%;
  border-top: solid 1px black;
  height: 0px;
`

export const RightLine = styled.div`
  position: relative;
  right: 5%;
  width: 40%;
  border-top: solid 1px black;
  height: 0px;
`

export const OrText = styled.p`
  text-align: center;
  transform: translate(0, -50%);
  width: 20%;

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 13px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 11px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 10px;
  }

  /* tablets na vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 9px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 8px;
  }
`

export const GoogleDiv = styled.div`
  position: relative;
  left: 22.5%;
  width: 55%;
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 30px;
  margin: 20px 0 0 0;
`

export const GoogleDivImg = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 15%;
`

export const GoogleLogo = styled.img`
  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    width: 22px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    width: 20px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    width: 18px;
  }

  /* tablets na vertical/celulares grandes */
  @media (max-width: 768px) {
    width: 17px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    width: 12px;
  }
`

export const GoogleDivTxt = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 85%;
  vertical-align: middle;

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 14px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 13px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 12px;
  }

  /* tablets na vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 11px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 8px;
  }
`

export const RegisterDiv = styled.div`
  position: relative;
  left: 25%;
  width: 50%;

  display: flex;
  justify-content: center;
  align-items: center;

  min-height: 30px;

  margin: 20px 0 20px 0;

  border: rgb(0, 0, 0) solid 1px;
  border-radius: 5px;

  :hover {
    background-color: rgb(220, 220, 220);
    cursor: pointer;
  }

  /* RESPONSIVIDADE */

  /* laptop */
  @media (min-width: 1200px) {
    font-size: 14px;
  }

  /* laptop menor */
  @media (max-width: 1200px) {
    font-size: 13px;
  }

  /* tablets na horizontal */
  @media (max-width: 992px) {
    font-size: 12px;
  }

  /* tablets na vertical/celulares grandes */
  @media (max-width: 768px) {
    font-size: 11px;
  }

  /* celulares pequenos */
  @media (max-width: 600px) {
    font-size: 10px;
  }
`
export const ErrContainer = styled.div`
  text-align: center;
  color: red;
  font-weight: 400;
  font-size: 0.85rem;
`
